/**
 * @Author: Nenad Brcic
 * @Date: 22.05.16
 * @Email: neno@neno.ch
 */

import React from 'react';
import styles from './toolbar.scss'
import CSSModules from 'react-css-modules'
import localize from '../../../localize'

const Toolbar = (props) => {

    const l =(key) => {
        const str = `${props.lang}.components.MyCollection.${key}`;
        return localize(str);
    };
    
    return (
        <div styleName="toolbar">
            <div className="content-box">
                {
                    props.isEditMode ? (
                        <button type="button"
                                onClick={ () => props.deleteAll() }
                                styleName="button-deleteAll">
                            { l('buttonDeleteAll') }
                        </button>
                    ) : null
                }
                <button type="button"
                        onClick={ () => props.toggleEditMode() }
                        styleName="button-edit">
                    { l('buttonEdit') }
                </button>
            </div>
        </div>
    )
};

export default CSSModules(Toolbar, styles);


// WEBPACK FOOTER //
// ./app/components/MyCollection/MyCollectionToolbar/index.jsx